import type { SVGProps } from "react";

export const MicrosoftPowerBi = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 256 342" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Microsoft Power BI</title>
    <defs>
      <path
        d="M142.222222,14.2222222 C142.222222,6.36750222 148.589867,0 156.444444,0 L241.777778,0 C249.632356,0 256,6.36750222 256,14.2222222 L256,327.111111 C256,334.965689 249.632356,341.333333 241.777778,341.333333 L14.2222222,341.333333 C6.36764444,341.333333 0,334.965689 0,327.111111 L0,184.888889 C0,177.034311 6.36764444,170.666667 14.2222222,170.666667 L71.1114667,170.666667 L71.1114667,99.5555556 C71.1114667,91.7009778 77.4791111,85.3333333 85.3336889,85.3333333 L142.222222,85.3333333 L142.222222,14.2222222 Z"
        id="mpb_path"
      />
      <linearGradient
        id="mpb_g1"
        x1="42.5926042%"
        x2="57.2448958%"
        y1="0%"
        y2="93.1735417%"
      >
        <stop offset="0%" stopColor="#E6AD10" />
        <stop offset="100%" stopColor="#C87E0E" />
      </linearGradient>
      <linearGradient
        id="mpb_g2"
        x1="40.1218519%"
        x2="62.0283333%"
        y1="0%"
        y2="95.5919444%"
      >
        <stop offset="0%" stopColor="#F6D751" />
        <stop offset="100%" stopColor="#E6AD10" />
      </linearGradient>
      <linearGradient
        id="mpb_g3"
        x1="27.7741667%"
        x2="55.0115278%"
        y1="0%"
        y2="96.828125%"
      >
        <stop offset="0%" stopColor="#F9E589" />
        <stop offset="100%" stopColor="#F6D751" />
      </linearGradient>
    </defs>
    <g>
      <mask fill="white" id="mpb_mask">
        <use xlinkHref="#mpb_path" />
      </mask>
      <polygon
        fill="url(#mpb_g1)"
        mask="url(#mpb_mask)"
        points="256 0 256 341.333333 142.222222 341.333333 142.222222 0"
      />
      <path
        d="M184.888889,99.5555556 L184.888889,341.333333 L71.1111111,341.333333 L71.1111111,85.3333333 L170.666667,85.3333333 C178.521244,85.3333333 184.888889,91.7009778 184.888889,99.5555556 Z"
        fill="url(#mpb_g2)"
        mask="url(#mpb_mask)"
      />
      <path
        d="M0,170.666667 L0,341.333333 L113.777778,341.333333 L113.777778,184.888889 C113.777778,177.034311 107.410133,170.666667 99.5555556,170.666667 L0,170.666667 Z"
        fill="url(#mpb_g3)"
        mask="url(#mpb_mask)"
      />
    </g>
  </svg>
);

export default MicrosoftPowerBi;
